<section class="content_top_margin">
    <div *ngIf="flowType?.type==prequalType" class="sectionHeading_one bot_spa_aft_sect_heading">
        {{'Online Banking account.youcanborrow' | translate }} </div>
    <div *ngIf="flowType?.type ===switchType" class="sectionHeading_one bot_spa_aft_sect_heading">
        {{'Online Banking account.exclusiveOffer' | translate }} </div>
    <div *ngIf="flowType?.type==prequalType" class="sectionHeading_two bot_spa_aft_sect_heading">
        {{'Online Banking account.findOut' | translate }}
    </div>
    <ng-container *ngIf="flowType?.type ===switchType">
        <div class="d-flex align-items-start noteContainer  bot_spa_aft_sect_heading">
                <img src="./assets/icons/info-square-filled.svg" alt="" class="pr-2">
                <span>{{ 'Online Banking account.tooltipContentDigiSwtich' |translate}} </span>
        </div>
    </ng-container>
    <div class="row no-gutters">
        <div class="col-12">
            {{ 'Notyetaclient.CIBCstext' | translate }}
            <a [href]="privacyandsecurityLink" class="pr-0" target="_blank" data-toggle="tooltip" data-placement="top">
                <span class="note_link"> <u>{{'Notyetaclient.privacytitle' | translate}}</u></span>
                <span class="show-for-sr">{{'Notyetaclient.privacyPolicy' | translate}}</span>
            </a>
            {{ 'Notyetaclient.informationTxt' | translate }}
            <a [href]="privacyandsecurityLinkSummary" class="pr-0" target="_blank" data-toggle="tooltip"
                data-placement="top">
                <span class="note_link"><u> {{'Notyetaclient.summaryTxt' | translate}}</u></span>
                <span class="show-for-sr">{{'Notyetaclient.privacyPolicy' | translate}}</span>

            </a>
            <span>{{'Notyetaclient.dot'|translate}}</span>
        </div>
    </div>
    <div class="row no-gutters top_height_actionButton content_top_mobile_margin">
        <div class="col-12 d-md-block d-flex  flex-column-reverse">
            <cancel-button></cancel-button>
            <button type="button" class="common_btn saveNextBtn_features space_between_button"
                (click)="onContinue()">{{'buttonallpages.buttonlable' | translate }}</button>
        </div>
    </div>
</section>

